import { Col, Row } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EnumOrderItemStatus } from "../../../../../constants/enums";
import { formatTextCurrency, getCurrencySymbol, getLabelPromotion } from "../../../../../utils/helpers";
import { ArrowBoldDownIcon, ArrowBoldUpIcon, DeleteIcon, NoteIcon } from "../../../../assets/icons.constants";
import DisplayImageComponent from "../../../../components/display-image/DisplayImageComponent";
import { maximumQuantity } from "../../../../constants/number.constants";
import "./CartItemComponent.scss";

function CartItemComponent(props) {
  const {
    cartItem,
    onDeleteProduct,
    onUpdateCartQuantity,
    onEdit,
    index,
    isOrdered,
    isReceipt,
    branchId,
    showNotifyOutOfStock,
  } = props;
  const [isShowComboDetail, setIsShowComboDetail] = useState(false);
  const currencySymbol = getCurrencySymbol();
  const [t] = useTranslation();
  const pageData = {
    completed: t("posCart.completed", "Đã hoàn thành"),
    canceled: t("posCart.canceled", "Đã hủy"),
  };
  if (!cartItem) return <></>;

  const isCombo = cartItem?.isCombo;
  const isShowOriginalPrice =
    !cartItem?.isCombo && cartItem?.originalPriceIncludeTopping !== cartItem?.priceAfterDiscountIncludeTopping;

  let promotionTitle = "";
  if (cartItem?.isPromotion || cartItem?.productPrice?.isApplyPromotion) {
    promotionTitle =
      "-" +
      getLabelPromotion(
        cartItem?.isFlashSale,
        cartItem?.productPrice?.isPercentDiscount,
        cartItem?.productPrice?.discountValue,
        cartItem?.productPrice?.isApplyPromotion,
        cartItem?.productPrice?.originalPrice,
        cartItem?.productPrice?.priceValue,
        currencySymbol,
        false,
      );
  }

  const sizeName = isCombo ? undefined : cartItem?.productPrice?.priceName;
  const renderProductOptions = (options = []) => {
    const result = options
      ?.map((item) => (!item.isSetDefault ? item.name + ": " + item.optionLevelName : ""))
      ?.filter((item) => item !== "")
      ?.join(" / ");
    return result;
  };

  const renderProductToppings = (toppings = []) => {
    const result = toppings
      ?.filter((topping) => topping?.quantity > 0)
      ?.map((topping) => (
        <div className="topping-item">
          <div className="topping-text">{"x" + topping.quantity + " " + topping.name}</div>
        </div>
      ));

    return result;
  };

  const renderTotalQuantities = (cartItem) => {
    let itemsCompleted = cartItem?.quantityCompleted ?? 0;
    let itemsTotal = cartItem?.quantity;

    if (cartItem?.statusId === EnumOrderItemStatus.Canceled) {
      return "x" + itemsTotal;
    }

    if (cartItem?.statusId === EnumOrderItemStatus.Completed && itemsCompleted === itemsTotal) {
      return "x" + itemsCompleted;
    }

    if (isReceipt) {
      return "x" + itemsTotal;
    }

    return itemsCompleted + "/" + itemsTotal;
  };

  const renderTagStatus = (isOrdered, cartItem, isReceipt) => {
    let itemsCompleted = cartItem?.quantityCompleted ?? 0;
    let itemsTotal = cartItem?.quantity;
    if (!isOrdered || isReceipt) {
      return "";
    } else if (cartItem?.statusId === EnumOrderItemStatus.Completed && itemsCompleted === itemsTotal) {
      return <div className="item-completed">{pageData.completed}</div>;
    } else if (cartItem?.statusId === EnumOrderItemStatus.Canceled) {
      return <div className="item-canceled">{pageData.canceled}</div>;
    } else return <></>;
  };

  const showComboDetail = () => {
    setIsShowComboDetail(true);
  };

  const hideComboDetail = () => {
    setIsShowComboDetail(false);
  };

  return (
    <div className="pos-order-cart-item">
      <div className={`pos-cart-item-overall ${cartItem?.isOutOfStock ? "out-of-stock" : ""}`}>
        <div
          className="image"
          onClick={() => (isOrdered || isReceipt ? null : onEdit(cartItem.id, index))}
          style={{ cursor: isOrdered || isReceipt ? "default" : "pointer" }}
        >
          <DisplayImageComponent
            className="product-cart-item-image"
            promotionTag={promotionTitle}
            src={cartItem?.thumbnail}
            cartItem={cartItem}
          />
        </div>
        <Row wrap={false} className="content">
          <Col flex={"auto"} className="info">
            {renderTagStatus(isOrdered, cartItem, isReceipt)}
            <div
              className="name text-line-clamp-2"
              onClick={() => (isOrdered || isReceipt ? null : onEdit(cartItem.id, index))}
              style={{ cursor: isOrdered || isReceipt ? "default" : "pointer" }}
            >
              {cartItem?.name ??
                (cartItem?.comboTypeId === 0
                  ? cartItem?.dataDetails?.combo?.itemName ?? cartItem?.comboPricingName
                  : cartItem?.dataDetails?.name)}
              {sizeName ? " (" + sizeName + ")" : undefined}
            </div>
            <div className="option text-line-clamp-2">{renderProductOptions(cartItem?.options)}</div>
            <div className="topping">{renderProductToppings(cartItem?.toppings)}</div>
            <div className="price">
              <div className="selling-price">{formatTextCurrency(cartItem?.priceAfterDiscountIncludeTopping)}</div>
              {isShowOriginalPrice && (
                <div className="original-price">{formatTextCurrency(cartItem?.originalPriceIncludeTopping)}</div>
              )}
            </div>
          </Col>
          {!isOrdered && !isReceipt ? (
            <Col flex={"none"} className="action">
              <div className="change-quantity-group">
                <div
                  className="button-change-quantity down"
                  onClick={() => {
                    //If quantity = 1, do nothing
                    if (cartItem.quantity <= 1) {
                      return;
                    }
                    onUpdateCartQuantity(cartItem.id, -1, index, branchId, false);
                  }}
                >
                  <span>-</span>
                </div>
                <div className="quantity">{cartItem.quantity}</div>
                <div
                  className="button-change-quantity up"
                  onClick={() => {
                    if (cartItem.quantity >= maximumQuantity || cartItem?.isOutOfStock) return;
                    onUpdateCartQuantity(cartItem.id, 1, index, branchId, true, showNotifyOutOfStock);
                  }}
                >
                  <span className="quantity-icon">+</span>
                </div>
              </div>

              <div className="active-other">
                <div className="delete" onClick={() => onDeleteProduct(cartItem.id, index)}>
                  <DeleteIcon />
                </div>

                {cartItem?.isCombo ? (
                  <div className="show-combo-detail">
                    {
                      <>
                        {isShowComboDetail ? (
                          <ArrowBoldUpIcon onClick={hideComboDetail} />
                        ) : (
                          <ArrowBoldDownIcon onClick={showComboDetail} />
                        )}
                      </>
                    }
                  </div>
                ) : (
                  <div className="show-combo-detail-empty"></div>
                )}
              </div>
            </Col>
          ) : (
            <Col flex={"none"} className="action-quantity">
              <div className="active-other">
                <div className="number-product">{renderTotalQuantities(cartItem)}</div>

                {cartItem?.isCombo ? (
                  <div className="show-combo-detail">
                    {
                      <>
                        {isShowComboDetail ? (
                          <ArrowBoldUpIcon onClick={hideComboDetail} />
                        ) : (
                          <ArrowBoldDownIcon onClick={showComboDetail} />
                        )}
                      </>
                    }
                  </div>
                ) : (
                  <div className="show-combo-detail-empty"></div>
                )}
              </div>
            </Col>
          )}
        </Row>
      </div>
      {isShowComboDetail && (
        <div className="detail">
          {cartItem?.products?.map((product) => (
            <Row wrap={false} className="item">
              <Col flex={"none"} className="image">
                <DisplayImageComponent className="product-cart-item-image" src={product?.thumbnail} />
              </Col>
              <Col flex={"auto"} className="item-info">
                <div className="name">{product.name}</div>
                <div className="option">{renderProductOptions(product?.options)}</div>
                <div className="topping">{renderProductToppings(product?.toppings)}</div>
              </Col>
            </Row>
          ))}
        </div>
      )}
      {cartItem?.notes && (
        <div className="cart-item-note">
          <NoteIcon className="note-icon" />
          <div>
            <div className="note-text">{cartItem?.notes}</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CartItemComponent;
